import axios from './axios';

const getAll = async () => {

    return axios.get(`photosets`).then(response => response.data).then(data => ({items: prepare(data)}));
};

const getById = async (id) => {

    return axios.get(`photosets/${id}`).then(response => response.data).then(data => ({item: prepare(data)}));
};

const getByParameters = async (params) => {

    return axios.get(`photosets`, {params}).then(response => response.data).then(data => ({items: prepare(data)}));
};

const getLikesById = async (id) => {

    return axios.get(`photosets/${id}/like`).then(response => response.data).then(data => ({item: prepare(data)}));
};

const likeById = async (id) => {

    return axios.post(`photosets/${id}/like`); // TODO: prepare() if it returns data.
};

const prepare = (items) => {

    const wasArray = Array.isArray(items);

    items = (wasArray ? items : [items]).map(item => {

        const thumbnail = 'https://growapp.geodan.nl/uploads/small/' + item.thumbnail;
        const cacheBuster = window.localStorage.getItem('cacheBuster_' + thumbnail);

        return Object.assign(item, {

            gif: 'https://growapp.geodan.nl/uploads/' + item.gif,
            photos: item.photos.map(photo => {

                const filename = 'https://growapp.geodan.nl/uploads/' + photo.filename;
                const cacheBuster = window.localStorage.getItem('cacheBuster_' + filename);

                Object.defineProperty(photo, 'cacheBuster', {

                    set: function(value) {

                        this.filename = filename + `?${value}`;
                        window.localStorage.setItem('cacheBuster_' + filename, value);
                    },
                });

                photo.filename = filename + `?${cacheBuster || ''}`;
                photo.photoSet = item; // Add a circular reference so the photo set can always be accessed quickly.

                return photo;
            }),
            tags: item.photos.map(photo => photo.tags).reduce((a, b) => [...a, ...b]),
            thumbnail: thumbnail + `?${cacheBuster || ''}`,
        });
    });

    return wasArray ? items : items[0];
};

const updateById = async (id, {highlight}) => {

    return axios.put(`photosets/${id}`, {

        highlight,

    }).then(response => response.data).then(data => ({item: prepare(data)}));
};

export {

    getAll,
    getById,
    getByParameters,
    getLikesById,
    likeById,
    updateById,
}



// WEBPACK FOOTER //
// ./src/components/services/photoSets.js